<!--  -->
<template>
  <div class="anbpxr">
    <el-card shadow="never" style="margin-bottom: 10px;">
      <el-form :inline="true">
        <el-form-item label="选择日期">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            unlink-panels
            :clearable="false"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <!-- <el-button @click="handleReset">重置</el-button> -->
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <el-table :data="tableData" style="width: 100%;" border>
        <el-table-column prop="date" label="日期" align="center" />
        <el-table-column
          prop="total_count"
          label="记录总数"
          align="center"
          width="130"
        >
          <template scope="scope">
            <span style="color: #409EFF; font-weight: bold;">
              <i class="el-icon-document" />
              {{ scope.row.detail.total_count }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="total_approved"
          label="通过数"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <span style="color: #67C23A;">
              ✅ {{ scope.row.detail.total_approved }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="total_rejected"
          label="驳回数量"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <span style="color: #F56C6C;">
              ❌ {{ scope.row.detail.total_rejected }}
            </span>
          </template>
        </el-table-column>
        <!-- 文本驳回 -->
        <el-table-column
          label="文本数"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <span style="color: #409EFF; font-weight: bold;">
              <i class="el-icon-document" />
              {{ scope.row.detail.text_count || 0 }}
            </span>
          </template>
        </el-table-column>
        <!-- 文本通过 -->
        <el-table-column
          label="文本通过数"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <span style="color: #67C23A;">
              ✅ {{ scope.row.detail.text_approved || 0 }}
            </span>
          </template>
        </el-table-column>

        <!-- 图片通过 -->
        <el-table-column
          label="文本驳回数"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <span style="color: #F56C6C;">
              ❌ {{ scope.row.detail.text_rejected || 0 }}
            </span>
          </template>
        </el-table-column>
        <!-- 图片驳回 -->
        <el-table-column
          label="图片数"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <span style="color: #409EFF; font-weight: bold;">
              <i class="el-icon-document" />
              {{ scope.row.detail.image_count || 0 }}
            </span>
          </template>
        </el-table-column>
        <!-- 富文本通过 -->
        <el-table-column
          label="图片通过数"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <span style="color: #67C23A;">
              ✅ {{ scope.row.detail.image_approved || 0 }}
            </span>
          </template>
        </el-table-column>

        <!-- 文本总数 -->
        <el-table-column
          label="图片驳回数"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <span style="color: #F56C6C;">
              ❌ {{ scope.row.detail.image_rejected || 0 }}
            </span>
          </template>
        </el-table-column>
        <!-- 富文本驳回 -->
        <el-table-column
          label="富文本数"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <span style="color: #409EFF; font-weight: bold;">
              <i class="el-icon-document" />
              {{ scope.row.detail.rich_text_count || 0 }}
            </span>
          </template>
        </el-table-column>

        <!-- 图片总数 -->
        <el-table-column
          label="富文本通过数"
          align="center"
          width="130"
        >

          <template slot-scope="scope">
            <span style="color: #67C23A;">
              ✅ {{ scope.row.detail.rich_text_approved || 0 }}
            </span>
          </template>
        </el-table-column>
        <!-- 富文本总数 -->
        <el-table-column
          label="富文本驳回数"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <span style="color: #F56C6C;">
              ❌ {{ scope.row.detail.rich_text_rejected || 0 }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { landingPageH5memberdetails } from '@/api/publicPlan.js'
export default {
  components: {},
  data() {
    const today = new Date()
    const year = today.getFullYear()
    const month = today.getMonth()
    const firstDay = new Date(year, month, 1)

    const format = (d) => {
      const pad = (n) => (n < 10 ? '0' + n : n)
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    }

    const defaultDateRange = [format(firstDay), format(today)]
    return {
      created_by: null,
      pagination: {
        page: 1,
        page_size: 10,
        start_date: '', // 先留空
        end_date: ''
      },
      tableData: [],
      dateRange: defaultDateRange
    }
  },
  created() {
    this.created_by = this.$route.query.created_by
    this.pagination.start_date = this.dateRange[0]
    this.pagination.end_date = this.dateRange[1]
    console.log('this.$router:', this.$route.query.created_by)
    this.getData()
  },
  mounted() {

  },
  methods: {
    getData() {
      landingPageH5memberdetails({ ...this.pagination, created_by: this.created_by }).then((res) => {
        console.log('res', res)
        this.tableData = res.data
      })
    },
    handleSearch() {
      this.pagination.page = 1
      this.pagination.start_date = this.dateRange[0]
      this.pagination.end_date = this.dateRange[1]
      this.getData()
    },
    handleReset() {

    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.anbpxr{
  padding: 20px;
}
</style>
